import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Dropdown } from 'components/Dropdown/Dropdown';

import cube_icon from 'assets/img/cube.svg';
import time_icon from 'assets/img/time.svg';
import check_mark_icon from 'assets/img/check-mark.svg';
import refresh_icon from 'assets/img/refresh.svg';
import flag_black_icon from 'assets/img/flag-black.svg';
import calendar_icon from 'assets/img/calendar.svg';

import MaintenanceServices from './services';
import * as MaintenanceEnums from './maintenance-enums';

const CHOICE_LIST = [
  { value: 0, text: 'This month'},
  { value: 1, text: 'Next month'},
  { value: 2, text: 'Last month'}
];

export class TaskReminder extends Component {
  static propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    projectId: PropTypes.string,
    maintenanceTaskReminderList: PropTypes.array
  }

  constructor(props) {
    super(props);

    this.maintenanceService = new MaintenanceServices(this.props.dispatch);
    this.state = {
      selectedType: CHOICE_LIST[0]
    };
  }

  componentDidMount() {
    this.onChangeFromToDate(CHOICE_LIST[0]);
  }

  onChangeFromToDate = (e) => {
    // let fromDate = Moment(localStorage['TODAY']) || Moment();
    let fromDate = Moment();
    let toDate = null;

    switch (e.value) {
      case 0:
        fromDate.startOf('month');
        toDate = fromDate.clone().add(1, 'months').startOf('month');
        break;
      case 1:
        fromDate.add(1, 'months').startOf('month');
        toDate = fromDate.clone().add(1, 'months').startOf('month');
        break;
      case 2:
        toDate = fromDate.startOf('month');
        fromDate = toDate.clone().subtract(1, 'months');
        break;
      default:
        fromDate.startOf('day');
        toDate = fromDate.clone().add(1, 'days').startOf('day');
    }

    this.maintenanceService.getTaskReminderList(this.props.projectId, fromDate.format(), toDate.format());
    this.setState({selectedType: e});
  }

  renderTaskList() {
    return (
      <React.Fragment>

        <div className='container-fluid maintenance-task-list' >
          <div>
            <Dropdown
              name='reminder_period'
              style={{width: '300px'}}
              className='filestring-dropdown'
              optionLabel='text'
              options={CHOICE_LIST}
              value={this.state.selectedType}
              onChange={(e) => this.onChangeFromToDate(e.value)}
            />
          </div>
          {
            Array.isArray(this.props.maintenanceTaskReminderList) &&
            this.props.maintenanceTaskReminderList.map((lot) => {
              return (
                <div key={lot.id} style={{marginBottom: '20px'}}>
                  <b>{`${lot.lotName}, ${lot.lotAddress}`}</b>
                  {
                    Array.isArray(lot.reminders) &&
                    lot.reminders.map((r) => {
                      return (
                        <div key={_.uniqueId()} className='row'>
                          <div className='col-md-6'>
                            <img className='icon-first-col' src={r.recurringType ? time_icon : refresh_icon} />
                            <div className='block-with-text'>{r.name}</div>
                          </div>

                          <div className='col-md-2'>
                            <img className='icon' src={cube_icon} />
                            <div className='sub-block-text'>
                              {
                                r.inventoryItem &&
                                <Link target='_blank' to={this.maintenanceService.buildUrlToInventoryItem(this.props.projectId, r.inventoryItem.id)}>{r.inventoryItem.name}</Link>
                              }
                              {!r.inventoryItem && '--'}
                            </div>
                          </div>

                          <div className='col-md-2' style={{position: 'relative'}}>
                            <img className='icon' src={flag_black_icon} />
                            <div className='sub-block-text'>
                              {MaintenanceEnums.REPEAT_PERIODS_LIST[r.repeatType]}
                            </div>
                          </div>

                          <div className='col-md-2'>
                            <img className='icon' src={calendar_icon} />
                            <div className='sub-block-text'>
                              {Moment(r.reminderDate).format('MM/DD/YYYY')}
                              {r.isSent && <img className='icon icon-check-last' src={check_mark_icon} />}
                            </div>
                          </div>
                        </div>);
                    })
                  }
                </div>
              );
            })
          }
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      this.renderTaskList()
    );
  }
}

const mapStateToProps = (state) => {
  return {
    maintenanceTaskReminderList: state.ProjectStore.MaintenanceTaskReminderList
  };
};

export default withRouter(connect(mapStateToProps)(TaskReminder));



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-reminder.js